import { render, staticRenderFns } from "./showFiles.vue?vue&type=template&id=f64c1e28&scoped=true&"
import script from "./showFiles.vue?vue&type=script&lang=ts&"
export * from "./showFiles.vue?vue&type=script&lang=ts&"
import style0 from "./showFiles.vue?vue&type=style&index=0&id=f64c1e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64c1e28",
  null
  
)

export default component.exports